import {request} from '../request'

/**
 * 获取首页数据
 */
export function getContent(type) {
    let result =  request({
        url: "/agg-portal/ap/home/content?type="+type
    });
    return result;
}

/**
 * 品牌页详情
 * @param id
 * @returns {AxiosPromise}
 */
export function getBrandDetail(id) {
    return request({
        url: "/agg-portal/ap/brand/detail/" + id,
        method: 'get',
    });
}

/**
 * 品牌列表
 * @param condition
 * @returns {AxiosPromise}
 */
export function getBrandList(condition) {
    return request({
        url: "/agg-portal/ap/brand/recommendList",
        method: 'get',
        params: condition
    })
}

/**
 * 品牌相关产品列表
 * @param condition
 * @returns {AxiosPromise}
 */
export function getProductByBrand(condition) {
    return request({
        url: '/agg-portal/ap/brand/productList',
        method: 'get',
        params: condition
    })
}

/**
 *  添加品牌关注
 * @param memberBrandAttention
 * @returns {AxiosPromise}
 */
export function addBrandFocus(memberBrandAttention) {
    return request({
        url: '/agg-portal/ap/brand/productList',
        method: 'post',
        data: { memberBrandAttention: memberBrandAttention }
    })
}

/**
 * 取消商品关注
 * @param brandId
 * @returns {AxiosPromise}
 */
export function deleteBrandFocus(brandId) {
    return request({
        url: '/agg-portal/ap/member/attention/delete',
        method: 'post',
        params: { brandId: brandId }
    })
}

export function getUserInfo() {
    return request({
        url: '/agg-portal/ap/sso/info',
        method: 'get',
    })
}




